const INIT_STATE = {

    changePasswordModelVisible : false,
    editProfileModalVisible : false,
    planSettingsCompleted : false,
    isPasswordChanged : false,
    planeSettings : [],
    textMessage:'',
    isPlanSettingsFail:false,
    isPlanSettingsUpdated:false,
    settingsData:[],
    fetchingLoader: false,
    profileEditeSuccess:false

}
export default  (state = INIT_STATE, action) => {
    switch (action.type) {
        
        case 'gettingProfile_START': {
            return {
                ...state,
                fetchingLoader: true
            }
        }
        case 'getProfile_SUCCESS':{
            return{
                ...state,
                settingsData : action.payload.Record,
                isPlanSettingsUpdated : false,
                fetchingLoader: false
            }
        }

            case 'changePassword_Modal':{
                return {
                    ...state,
                    changePasswordModelVisible : !state.changePasswordModelVisible,
                    isPlanSettingsUpdated : false,
                    fetchingLoader: false
                }
            }
            case 'EditProfile_Modal':{
                return {
                    ...state,
                    editProfileModalVisible : !state.editProfileModalVisible,
                    isPlanSettingsUpdated : false,
                    fetchingLoader: false
                }
            }
            case 'planSettings_SUCCESS':{
                return{
                    ...state,
                    planSettingsCompleted : true,
                    isPlanSettingsUpdated : false,
                    fetchingLoader: false
                }
            }
            case 'resetPassword_SUCCESS':{
                return{
                    ...state,
                    changePasswordModelVisible : !state.changePasswordModelVisible,
                    isPasswordChanged : true,
                    isPlanSettingsUpdated : false,
                    fetchingLoader: false,
                    textMessage : 'your password has been changed successfully'
                }
            }
            case 'updateSetting_SUCCESS':{
                return{
                    ...state,
                    
                    isPlanSettingsUpdated : true,
                    textMessage : 'Plan settings have been updated successfully',
                    fetchingLoader: false
                }
            }
            case 'updateSetting_FAILURE':{
                return{
                    ...state,
                    isPlanSettingsFail : true,
                    textMessage : action.payload.message,
                    isPlanSettingsUpdated:false,
                    fetchingLoader: false
                }
            }
            case 'updateProfile_SUCCESS':{
                return{
                    ...state,
                    editProfileModalVisible : !state.editProfileModalVisible,
                    profileEditeSuccess : true,
                    settingsData : action.payload.Record,
                    textMessage:'profile has been updated successfully'
                }
            }

            case 'reset_profilesettings':{
                return{
                    ...state,
                    isPlanSettingsFail : false,
                    isPlanSettingsUpdated:false,
                    fetchingLoader: false,
                    isPasswordChanged : false,
                    profileEditeSuccess:false
                    
                }
            }

        
        default:
            return state
    }
}


 